'use strict';
import "./styles/global.scss";
import "./styles/aboutPage.scss";
import "./styles/speakerPage.scss";
import "./styles/companyPage.scss";
import "./styles/oneToOnePage.scss";
import "./styles/strategicAdvisoryLongevityPage.scss";
import "./styles/thankYouPage.scss";
import "./styles/freebiePage.scss";
import "./styles/freebieNewsletterPage.scss";
import "./styles/blogPage.scss";
import "./styles/articlePage.scss";
import "./styles/home.scss";
import "./styles/section-headings.scss";

import './scripts/modules/global.js';
import initExternalLinks from './scripts/modules/external-links.js';

// Blog pagination scroll — deferred module runs after DOM parse (before DOMContentLoaded)
if (
	document.getElementById('blog-insights') &&
	(/\/p\d+\/?$/.test(window.location.pathname) || window.location.hash === '#blog-insights')
) {
	import('./scripts/modules/blog-pagination-scroll.js').then(m => m.default());
}

// Conditional — loaded only when the element exists on the page
document.addEventListener('DOMContentLoaded', () => {
	initExternalLinks();

	if (document.querySelector('[data-reveal]')) {
		import('./scripts/modules/section-reveal.js').then(m => m.default());
	}
	if (document.querySelector('.intro__fog-blob--1')) {
		const loadIntroScene = () => import('./scripts/modules/intro-scene.js').then(m => m.default());
		if ('requestIdleCallback' in window) {
			requestIdleCallback(loadIntroScene, { timeout: 2500 });
		} else {
			setTimeout(loadIntroScene, 1);
		}
	}
	if (document.querySelector('.intro__signature-svg')) {
		import('./scripts/modules/intro-signature-draw.js').then(m => m.default());
	}
	if (document.querySelector('[data-accordion]')) {
		import('./scripts/modules/accordion.js').then(m => m.default());
	}
	if (document.querySelector('.faq-clarity__watermark') || document.querySelector('.how-jan-works__gutter')) {
		import('./scripts/modules/faq-clarity-bird.js').then(m => m.default());
	}
	if (document.querySelector('.clients-marquee')) {
		import('./scripts/modules/clients-marquee.js').then(m => m.default());
	}
	if (document.querySelector('.js-split-quotes-swiper')) {
		import('./scripts/modules/split-showcase-swiper.js').then(m => m.default());
	}
	if (document.querySelector('.js-experts-swiper')) {
		import('./scripts/modules/experts-swiper.js').then(m => m.default());
	}
	if (document.querySelector('.odometer')) {
		import('./scripts/modules/odometer-init.js').then(m => m.default());
	}
	if (document.querySelector('.js-pill-counter')) {
		import('./scripts/modules/social-pill-counter.js').then(m => m.default());
	}
	if (document.querySelector('.video, .vision-video')) {
		import('./scripts/modules/video-create.js').then(m => m.default());
	}
	if (
		document.querySelector('.solution__bg-mountains') ||
		document.querySelector('.problem-impact-cluster__bg-mountains')
	) {
		import('./scripts/modules/solution-parallax.js').then(m => m.default());
	}
	if (document.querySelector('.philosophy__bg-mountains')) {
		import('./scripts/modules/philosophy-parallax.js').then(m => m.default());
	}
	if (document.querySelector('.testimonials-cluster') || document.querySelector('.video-testimonials')) {
		import('./scripts/modules/testimonials-cluster.js').then(m => m.default());
	}
	if (document.querySelector('.js-testimonials-reviews-swiper')) {
		import('./scripts/modules/testimonials-reviews-swiper.js').then(m => m.default());
	}
	if (document.querySelector('.js-video-testimonials-swiper')) {
		import('./scripts/modules/video-testimonials-swiper.js').then(m => m.default());
		}
		if (document.querySelector('[data-testimonial-message]')) {
			import('./scripts/modules/testimonials-readmore.js').then(m => m.default());
		}
	if (document.querySelector('[data-consent-checkbox]')) {
		import('./scripts/modules/form-consent.js').then(m => m.default());
	}
	if (document.querySelector('.js-case-detail-swiper')) {
		import('./scripts/modules/case-detail-swiper.js').then(m => m.default());
	}
	if (document.querySelector('.journey-path__cards')) {
		import('./scripts/modules/journey-path-cards.js').then(m => m.default());
	}
	if (document.querySelector('.training-structure')) {
		import('./scripts/modules/training-structure.js').then(m => m.default());
	}
	if (document.querySelector('.training-cluster__bg-mountains')) {
		import('./scripts/modules/training-parallax.js').then(m => m.default());
	}
	if (document.querySelector('.vitality-cluster__bg-mountains')) {
		import('./scripts/modules/vitality-parallax.js').then(m => m.default());
	}
	if (
		document.querySelector('.experience-freedom__discover-svg') ||
		document.querySelector('.vision-story__signature-svg') ||
		document.querySelector('.how-jan-works__signature-svg') ||
		document.querySelector('.philosophy__signature-svg') ||
		document.querySelector('.functional-longevity-loop__signature-svg')
	) {
		import('./scripts/modules/testimonials-signature-draw.js').then(m => m.default());
	}
	if (document.querySelector('.js-magnetic')) {
		import('./scripts/modules/magnetic-button.js').then(m => m.default());
	}
	if (document.querySelector('.article-toc')) {
		import('./scripts/modules/article-toc.js').then(m => m.default());
	}
	if (document.querySelector('[data-exit-intent-popup]')) {
		import('./scripts/modules/exit-intent-popup.js').then(m => m.default());
	}
	if (document.querySelector('.functional-longevity-loop')) {
		import('./scripts/modules/fll-bird-animation.js').then(m => m.default());
	}
});